// extracted by mini-css-extract-plugin
module.exports = {"tasks":"Tasks_tasks__Hc-0w","message":"Tasks_message__1xnwK"};